import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  divider: {
    margin: '0.75rem 0',
    width: '50%'
  },

  color: {
    margin: '0.75rem 0'
  },

  input: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0 1rem 0',
    height: '40px',
    paddingBottom: '0.25rem',

    '& input': {
      flex: '1',
      border: 'none',
      outline: 'none',
      fontSize: theme.size.sm
    }
  },

  dropdown: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0',

    '& > :first-child': {
      marginRight: '0.5rem'
    },

    '& .menu': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.border.outline}`,
      borderRadius: '5px',
      boxSizing: 'border-box',
      padding: '0.25rem',

      '& svg': {
        width: '0.75rem',
        height: '0.75rem'
      },

      '& > :first-child': {
        color: theme.palette.textAlt,
        marginRight: '1rem'
      }
    }
  },

  contactNumbers: {
    display: 'flex',
    flexFlow: 'column',
    color: theme.palette.textAlt,

    '& label': {
      display: 'inline-block',
      width: '5rem'
    },

    '& > div': {
      display: 'flex',
      flexFlow: 'column',
      margin: '2px 0px'
    },
    '& input': {
      marginLeft: '0.125rem',
      border: 'none',
      outline: 'none',
      margin: '5px 0px'
    },
    '& small': {
      color: 'red',
      margin: '2px 0px'
    }
  },

  warning: {
    color: theme.palette.indicator.red
  },

  hoursBlock: {
    display: 'flex',
    flexDirection: 'column'
  },

  hours: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.textAlt,
    marginBottom: '0.5rem',

    '& > div': {
      marginRight: '0.5rem'
    },

    '& .input': {
      width: '4rem',
      marginRight: '0.125rem',

      '& .MuiInput-input': {
        textAlign: 'center'
      }
    },

    '& .delete': {
      marginLeft: '1.5rem',
      cursor: 'pointer'
    }
  },

  hoursTicks: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',

    '& > :not(:last-child)': {
      marginRight: '0.5rem'
    }
  },

  hoursTick: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',

    '& .MuiCheckbox-root': {
      marginRight: '0 !important'
    },

    '& > :first-child': {
      justifyContent: 'center'
    },

    '& > :last-child': {
      color: theme.palette.textAlt
    }
  },

  addHours: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    color: 'lightgrey',
    cursor: ({ addHoursDisabled }) =>
      addHoursDisabled ? 'default' : 'pointer',

    '& .button': {
      fontSize: theme.size.base,
      marginRight: '0.5rem',
      width: '1rem',
      height: '1rem'
    }
  },
  deleteButton: {
    color: 'red',
    border: '0.125rem solid rgba(255, 0, 0, 0.35)',
    padding: '0 0.5rem',
    marginTop: '1rem'
  }
}))

export default useStyles
